import {
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";

const SearchBox = (props: InputProps) => {
  return (
    <InputGroup size={"sm"}>
      <InputLeftElement pointerEvents="none">
        <Icon as={FiSearch} />
      </InputLeftElement>
      <Input
        placeholder="Search"
        {...props}
      />
    </InputGroup>
  );
};

export default SearchBox;
